import React, { useEffect } from "react";
import { Redirect, Route, withRouter } from "react-router-dom";
import Header from "../components/consumer/Header";
import { useQuery, useQueryClient } from "react-query";
import { loadCurrentUser } from "../queries/session";
import PropTypes from "prop-types";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
import toast from "react-hot-toast";
import useSession from "../components/common/useSession";
import isEmpty from "lodash/isEmpty";
import PageNotFound from "../components/PageNotFound";
import axios from "axios";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const ConsumerRoute = ({
  condition,
  cableApp,
  component: Component,
  ...rest
}) => {
  const [jwt, isAuthenticated] = useSession();
  const queryClient = useQueryClient();
  const { isLoading, data: currentUser } = useQuery(
    "currentUser",
    async () =>
      await loadCurrentUser(source.token).then((user) => {
        cableApp.cable["_url"] = `${cableApp.cable["url"]}?jwt=${jwt}`;
        return user;
      }),
    {
      keepPreviousData: true,
      enabled: isAuthenticated(),
    }
  );
  useEffect(() => {
    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, [currentUser]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() &&
        !isLoading &&
        !isEmpty(currentUser.organization) &&
        condition.includes(currentUser.type) ? (
          <>
            <Header queryClient={queryClient} currentUser={currentUser} />
            <div className="content">
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Component
                  {...props}
                  queryClient={queryClient}
                  cableApp={cableApp}
                  currentUser={currentUser}
                  toast={toast}
                />
              </ErrorBoundary>
            </div>
          </>
        ) : isAuthenticated() &&
          !isLoading &&
          isEmpty(currentUser.organization) ? (
          <Redirect to="/organizations/new" />
        ) : !isAuthenticated() && !isLoading ? (
          <Redirect to="/login" />
        ) : !isEmpty(currentUser) &&
          !isLoading &&
          !condition.includes(currentUser.type) ? (
          <PageNotFound />
        ) : null
      }
    />
  );
};

ConsumerRoute.propTypes = {
  cableApp: PropTypes.object.isRequired,
  condition: PropTypes.array.isRequired,
};

export default withRouter(ConsumerRoute);
